import React, { useEffect, useState } from "react";
import { CustomIcon, CustomLockedNumberButton, CustomLockedNumberButtonContainer, CustomNumberButton, CustomNumberButtonContainer, CustomNumberSelectorContainer } from "./TicketNumberSelector.style";
import { Tooltip } from "../Tooltip/Tooltip";
export interface CustomTicketNumberSelectorProps {
    size?: number;
    maxTicketNumber?: number;
    defaultTicketNumber?: number;
    onTicketNumberChange: (selectedNumber: number) => void;
}

export const TicketNumberSelector = ({
    size = 6,
    maxTicketNumber = 4,
    defaultTicketNumber = 1,
    onTicketNumberChange
}: CustomTicketNumberSelectorProps) => {
    
    const selectableButtons = Array.from({ length: maxTicketNumber }, (_, index) => index + 1);
    const disabledButtons = Array.from({ length: size - maxTicketNumber }, (_, index) => index + maxTicketNumber + 1);

    const [ticketNumber, setTicketNumber] = useState(defaultTicketNumber);

    useEffect(() => {
        setTicketNumber(defaultTicketNumber);
    }, [defaultTicketNumber]);

    const handleChange = (clickedNumber: number) => {
        onTicketNumberChange(clickedNumber);
        setTicketNumber(clickedNumber);
    };

    return (
        <CustomNumberSelectorContainer>
            {selectableButtons.map((x, i) =>
                <CustomNumberButtonContainer data-cy={`ticket-number-selector-no${i}`} key={`CustomNumberButton-${i}`} className={maxTicketNumber == size ? 'is-all-available' : ''}>
                    <CustomNumberButton
                        key={i}
                        value={x}
                        onClick={() => handleChange(x)}
                        className={ticketNumber == x ? 'is-selected' : ''}>
                        {x}
                    </CustomNumberButton>
                </CustomNumberButtonContainer>
            )}
            {disabledButtons.map((x, i) =>
                <CustomLockedNumberButtonContainer key={`CustomLockedNumberButton-${i}`} className={maxTicketNumber == 0 ? 'is-all-locked' : ''}>
                    <Tooltip tooltipName="goldMember">
                        <CustomLockedNumberButton
                            key={i}
                            value={x}>
                            {x}
                        </CustomLockedNumberButton>
                    </Tooltip>
                    <CustomIcon icon="LockClosed" />
                </CustomLockedNumberButtonContainer>
            )}
        </CustomNumberSelectorContainer>
    );
};

export interface TicketNumberSelectorProps extends React.ComponentProps<typeof TicketNumberSelector> {
    as?: React.ElementType;
}

TicketNumberSelector.displayName = "TicketNumberSelector";
